/**
 * ALWAYS-ON stream-health NDJSON forwarder (production-safe).
 *
 * The sibling webrtcDebugSink is debug-build-gated; this one is not. It forwards a serialized
 * per-session health line to the on-disk sink in the host-electron main process
 * (`stream-health.ndjson` under ProgramData) so a field session's stream health can be
 * replayed from disk in production, not just in a debug rig.
 *
 * The host window runs with contextIsolation on from a remote origin, so the page has no
 * filesystem access; the only path to disk is the `appendStreamHealth` preload bridge.
 * Outside host-electron (plain browser, tests) this is a no-op. Fire-and-forget: a failed
 * IPC never surfaces to the caller, and the main process serializes appends so concurrent
 * 1 Hz peers cannot interleave JSON lines.
 */
export function sinkStreamHealthLine(line: string): void {
  try {
    const bridge = (
      window as unknown as { playcast?: { appendStreamHealth?: (l: string) => Promise<void> } }
    ).playcast;
    if (typeof bridge?.appendStreamHealth !== 'function') return;
    void bridge.appendStreamHealth(line).catch(() => undefined);
  } catch {
    // No window / no bridge — browser-hosted page or test; the line is dropped silently.
  }
}
